import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import "./rating-phase.scss"






const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);





export default function CustomizedSlider({ratingSliderTitle, value}) {

  return (
    
      <div className="rating-phase">
            <div className="rating-phase-title">
                    <span>{ratingSliderTitle}</span>
            </div>
            <div className="rating-slider">
                  <PrettoSlider valueLabelDisplay="auto" aria-label="pretto slider" defaultValue={value} />
            </div>
      </div>
       
  );
}
